const personAccessRejection = {
	name: 'Abgelehnter Zugang',
	fields: {
		lastname: 'Name',
		hp_id: 'ERP-Nummer',
		rejected_at: 'Abgelehnt am',
		status: 'Status',
		open_since_days: 'Offen seit',
		actions: 'Aktionen',
	},
}

export default personAccessRejection
